import './scss/main.scss';
import './index.css';
import {AppRoutes} from 'app-routes';
import 'chartjs-adapter-moment';
import 'chartjs-plugin-annotation';
import {PostHogProvider} from '@posthog/react';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter as Router} from 'react-router-dom';
import {ToastProvider} from 'react-toast-notifications';
import {store} from 'redux/store';
import reportWebVitals from 'reportWebVitals';
import {HubspotTrackPageView} from 'utils/hubspot';
import {posthog, PosthogIdentifyUser} from 'utils/posthog';
import {Toast} from './components/Toast';

// const defaults = Chart.defaults;
// defaults.font.family = 'Calibri';

const App = (): React.ReactElement => {
  return (
    <div className="bg-background text-foreground">
      <PostHogProvider client={posthog}>
        <Provider store={store}>
          <ToastProvider components={{Toast}} autoDismiss autoDismissTimeout={3000} newestOnTop>
            <Router
              future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
              }}>
              <AppRoutes />
              <HubspotTrackPageView />
              <PosthogIdentifyUser />
            </Router>
          </ToastProvider>
        </Provider>
      </PostHogProvider>
    </div>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
